import dateFormat from 'dateformat'

/* Capitalize first sign letter */
export function titleCase(string) {
    return string[0].toUpperCase() + string.slice(1).toLowerCase();
}

/* -- */
export function lowerCase(string) {
    return string.toLowerCase();
}

/* Format lex40ID from regular id (0,1,2...) */
export function formatLex40Id(string) {
    var aux = "w00";
    if (string < 10) {
        aux = "w000"
    }
    return aux.concat(string);
}

/* Postman anonymous data */
export function formatAnonymous(string) {
    const aux = "invitado_"
    return aux.concat(string);
}

/* Round probabilities */
export function prob2Percentage(string) {
    var aux = parseFloat(string)
    return (aux * 100).toFixed()
}

/* Date */
export function formatDate(date) {
    var today = new Date();

    if (today.getDate() === date.getDate() && today.getMonth() === date.getMonth()) return "Hoy, " + dateFormat(date, 'H":"MM');
    return dateFormat(date, 'dddd, d "de" mmmm')
}

/* Sort date */
export function sortDate(a, b) {
    /* Turn your strings into dates, and then subtract them
    to get a value that is either negative, positive, or zero */
    return new Date(b.date) - new Date(a.date);
}


// export function formatHistoryDate(timestamp) {
//     return new Intl.DateTimeFormat('en-US', {year: 'numeric', month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(timestamp)
// }

export function formatHistoryDate(timestamp) {

    let timestampMilliseconds = timestamp;
    if (timestamp.length === 16) {
        timestampMilliseconds = timestamp / 1000;
    }

    if (timestamp.toString().length < 13) {
        const digitDifference = 13 - timestamp.toString().length;
        timestampMilliseconds = timestamp * Math.pow(10, digitDifference);
    }
    
    return new Intl.DateTimeFormat('es-ES', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }).format(timestampMilliseconds);
  }

  export function formatDiffDate(timeDiff) {
    // console.log("🚀 ~ file: strings.js:72 ~ formatDiffDate ~ timestamp:", timestamp)

    // let lengthDifference = 13 - timestamp.toString().length;
    // if (lengthDifference > 0) {
    //     timestamp *= Math.pow(10, lengthDifference);
    // } else if (lengthDifference < 0) {
    //     timestamp = Math.floor(timestamp / Math.pow(10, -lengthDifference));
    // }

    // const now = new Date();
    // const deadline = new Date(parseInt(timestamp, 10));
    // const timeDiff = deadline - now;


    // console.log("🚀 ~ file: strings.js:72 ~ formatDiffDate ~ now:", now)
    // console.log("🚀 ~ file: strings.js:72 ~ formatDiffDate ~ deadline:", deadline)
    // console.log("🚀 ~ file: strings.js:72 ~ formatDiffDate ~ timeDiff:", timeDiff)

    // Calculate days, hours, minutes, and seconds remaining
    const timeDiff_abs = Math.abs(timeDiff);

    const days = Math.floor(timeDiff_abs/ (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDiff_abs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDiff_abs % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDiff_abs % (1000 * 60)) / 1000);

    if (timeDiff > 0) {
        return `${days}d ${hours}h ${minutes}m ${seconds}s`;
    }else{
        return `Tiempo expirado`;
    }
  }


export function formatDurationHourMinuteSecond(durationMilliseconds) {

    const hours = Math.floor(durationMilliseconds / (1000 * 60 * 60)) % 24;
    const minutes = Math.floor((durationMilliseconds / (1000 * 60)) % 60);
    const seconds = Math.floor((durationMilliseconds / 1000) % 60);
    const milliseconds = durationMilliseconds % 1000

    // console.log("hours", hours)
    // console.log("minutes", minutes)
    // console.log("seconds", seconds)
    // console.log("milliseconds", milliseconds)

    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(seconds).padStart(2, '0');
    const formattedMilliseconds = String(milliseconds).padStart(4, '0');

    // let out = '';
    // if (hours > 0) {
    //   out += `${formattedHours}:`;
    // }
    // if (hours > 0 || minutes > 0) {
    //   out += `${formattedMinutes}:`;
    // }
    // out += `${formattedSeconds}.${formattedMilliseconds}`;
    // out += `${formattedSeconds}`;

    const out = `${formattedHours}:${formattedMinutes}:${formattedSeconds}`

    return out
  }




export function formatGlossNormalizated(str) {
    const accentsMap = { Á: "A", É: "E", Í: "I", Ó: "O", Ú: "U" };

    let formattedString = str.toUpperCase();
    formattedString = formattedString.replace('*', '');
    formattedString = formattedString.split("").map(char => accentsMap[char] || char).join("");
    formattedString = formattedString.trim();
    formattedString = formattedString.replace(/\s+/g, " ");


    return formattedString;
  }